import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import frCommon from '@/locales/fr/common.json';
import enCommon from '@/locales/en/common.json';
import esCommon from '@/locales/es/common.json';
import deCommon from '@/locales/de/common.json';
import itCommon from '@/locales/it/common.json';

const resources = {
  fr: {
    common: frCommon,
  },
  en: {
    common: enCommon,
  },
  es: {
    common: esCommon,
  },
  de: {
    common: deCommon,
  },
  it: {
    common: itCommon,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    // Enable pluralization
    pluralSeparator: '_',
  });

export default i18n;
